module.exports = __webpack_public_path__ + "img/prioritas_cod.84b8e391.png";